import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Button, Icon, Modal } from 'semantic-ui-react';

import SnukForm from './SnukForm';
import Info from './Info';

const EditableInfo = (props) => {
  const {
    t, modalSize, reduxState, title, submitAction, isModalOpen, openModalAction, closeModalAction,
    schema, shape, ...rest
  } = props;
  const { isError, message, isPending } = reduxState;
  return (
    <div>
      <Info
        shape={shape}
        values={reduxState}
      />
      <Button
        style={{ marginTop: '20px' }}
        icon
        size="small"
        primary
        labelPosition="left"
        floated="left"
        onClick={openModalAction}
      >
        <Icon name="edit" />
        {t('accountConfig.edit')}
      </Button>
      {isModalOpen
        && (
        <Modal open size={modalSize || 'medium'}>
          <Modal.Header className="modal-header">
            {title}
          </Modal.Header>
          <Modal.Content>
            <SnukForm
              schema={schema}
              shape={shape}
              btnText={t('accountConfig.update')}
              initValues={reduxState}
              externalMessage={{ isError, messages: message.length > 1 ? [t(`backend.${message}`)] : [] }}
              isPending={isPending}
              onCancelAction={closeModalAction}
              onSubmitAction={submitAction}
              {...rest}
            />
          </Modal.Content>
        </Modal>
        )
      }
    </div>
  );
};

EditableInfo.propTypes = {
  t: PropTypes.func.isRequired,
  submitAction: PropTypes.func.isRequired,
  openModalAction: PropTypes.func.isRequired,
  closeModalAction: PropTypes.func.isRequired,
  shape: PropTypes.shape({}).isRequired,
  schema: PropTypes.shape({}).isRequired,
  reduxState: PropTypes.shape({}).isRequired,
  title: PropTypes.string.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  modalSize: PropTypes.string,
};

EditableInfo.defaultProps = {
  modalSize: 'medium',
};

export default translate()(EditableInfo);



// WEBPACK FOOTER //
// ./src/components/reusable/EditableInfo.js